import _ from "../../../../../lib/lodash.custom.min";

export default {
	pager: _.template(require("html!./pager.template.html")),
	deptCondition: _.template(require("html!./dept-condition.template.html")),
	destCondition: _.template(require("html!./dest-condition.template.html")),
	courseCalendar: _.template(require("html!./course-calendar.template.html"))
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/landing/templates/index.js